import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { fileUrl } from "@/lib/api";

const DOT = { draft: "bg-slate-500", generating: "bg-violet-400", ready: "bg-emerald-400", approved: "bg-amber-400", failed: "bg-red-400" };

export const FilmStrip = ({ scenes, activeId, onSelect }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.querySelector(`[data-active="true"]`)?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [activeId]);
  return (
    <div className="panel p-0 overflow-hidden" data-testid="film-strip">
      <div className="sprocket bg-[#181D2B]" />
      <div ref={ref} className="flex gap-2 overflow-x-auto px-3 py-3 bg-[#181D2B]">
        {scenes.map((s) => (
          <button key={s.id} data-testid={`strip-scene-${s.number}`} data-active={s.id === activeId} onClick={() => onSelect(s.id)}
            className={`shrink-0 w-32 rounded-md overflow-hidden border text-left transition-colors ${s.id === activeId ? "border-amber-400" : "border-[#2A3245] hover:border-[#3B4662]"}`}>
            <div className={`aspect-video bg-[#090A0F] relative ${s.status === "generating" ? "scan" : ""}`}>
              {s.thumb_path && <img src={fileUrl(s.thumb_path)} alt="" className="w-full h-full object-cover" />}
              {s.status === "generating" && <Loader2 className="w-4 h-4 animate-spin text-violet-300 absolute inset-0 m-auto" />}
              <span className={`absolute top-1 right-1 w-2 h-2 rounded-full ${DOT[s.status]}`} />
            </div>
            <div className="px-2 py-1 bg-[#11141E] flex justify-between font-mono text-[10px]">
              <span className="text-amber-400">{String(s.number).padStart(3, "0")}</span>
              <span className="text-slate-500">00:20</span>
            </div>
          </button>
        ))}
      </div>
      <div className="sprocket bg-[#181D2B]" />
    </div>
  );
};
